import React, { useContext } from 'react'
import { Row, Container, Button } from 'react-bootstrap'
import { DefaultSpinner } from './Spinners'
import { hwcrypto } from '../../utils/hwcrypto'
import { useTranslation } from 'react-i18next'
import httpClient from '../../services/httpClient'
import { IdCardHelpText } from './IdCardContentBlock'
import SigningContext from '../../contexts/SigningContext'
import { appInsights } from '../../appInsights'

function IdCardSignBLock() {
    const { t, i18n } = useTranslation()
    const [waiting, setWaiting] = React.useState(false)
    const { signingRequest, setError, setSigned } = useContext(SigningContext)

    const id = signingRequest?.id ?? ''

    async function initiateSign() {
        setError(undefined)

        setWaiting(true)

        try {
            const certificate = await hwcrypto.getCertificate({
                lang: i18n.language,
            })
            //const certificate = { hex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};
            console.warn(certificate, 'certificate')

            const signInitiate = await httpClient.idCardSignInitiate(
                id,
                certificate.hex
            )

            //const signature = { "hex": "BCF5BC96D99B5EBD9F12E55EA6AA9C3859718EF52F121841EE1AE6B2051243CDAAA6F3B2415D8A92F52B78280114C8A53C6363E6CCD2A00A13837B73BD399D659904A30E13A81D9CCEB5F5B3846EDC414241A2322D2EF40B55DE01B4AA0BD747", "value": { "0": 188, "1": 245, "2": 188, "3": 150, "4": 217, "5": 155, "6": 94, "7": 189, "8": 159, "9": 18, "10": 229, "11": 94, "12": 166, "13": 170, "14": 156, "15": 56, "16": 89, "17": 113, "18": 142, "19": 245, "20": 47, "21": 18, "22": 24, "23": 65, "24": 238, "25": 26, "26": 230, "27": 178, "28": 5, "29": 18, "30": 67, "31": 205, "32": 170, "33": 166, "34": 243, "35": 178, "36": 65, "37": 93, "38": 138, "39": 146, "40": 245, "41": 43, "42": 120, "43": 40, "44": 1, "45": 20, "46": 200, "47": 165, "48": 60, "49": 99, "50": 99, "51": 230, "52": 204, "53": 210, "54": 160, "55": 10, "56": 19, "57": 131, "58": 123, "59": 115, "60": 189, "61": 57, "62": 157, "63": 101, "64": 153, "65": 4, "66": 163, "67": 14, "68": 19, "69": 168, "70": 29, "71": 156, "72": 206, "73": 181, "74": 245, "75": 179, "76": 132, "77": 110, "78": 220, "79": 65, "80": 66, "81": 65, "82": 162, "83": 50, "84": 45, "85": 46, "86": 244, "87": 11, "88": 85, "89": 222, "90": 1, "91": 180, "92": 170, "93": 11, "94": 215, "95": 71 } }
            const signature: any = await hwcrypto.sign(
                certificate,
                { type: 'SHA-256', hex: signInitiate?.digest },
                { lang: i18n.language }
            )
            console.warn(JSON.stringify(signature), 'signature')

            await completeSigning(
                signature.hex || '',
                id,
                signInitiate?.containerID || ''
            )
        } catch (exception) {
            appInsights.trackException({ exception })
            setError(exception)
            setWaiting(false)
        }
    }

    async function completeSigning(
        signatureValue: string,
        signingRequestId: string,
        containerId: string
    ) {
        const data = await httpClient.idCardSignComplete(
            signingRequestId,
            signatureValue,
            containerId
        )

        setWaiting(false)

        if (data && data.url) {
            window.location.replace(data.url)
        } else {
            setSigned()
        }
    }

    return (
        <Row>
            <Container id="IdCardSignBlock">
                {waiting ? (
                    <DefaultSpinner />
                ) : (
                    <>
                        <IdCardHelpText />
                        <Button onClick={initiateSign} variant="primary">
                            {t('Proceed')}
                        </Button>
                    </>
                )}
            </Container>
        </Row>
    )
}

export default IdCardSignBLock
